import React, { Component } from 'react'
import { Context } from '../../Context'
import logo from '../../../assets/rhomberg-logo.svg'
import ServicesIcon from '../../../assets/icons/services.svg'
import ReferencesIcon from '../../../assets/icons/reference_image.svg'
import Mouse from '../../../assets/mouse.png'
import IconLink from '../../Libs/IconLink'
import AnimatedLogo from '../../Libs/AnimatedLogo'
import AnimatedBackgroundImage from '../../Libs/AnimatedBackgroundImage'

export default class Home extends Component {
    static contextType = Context

    constructor(props) {
        super(props)

        this.state = {
            itemIndexRingAnimation: null,
        }
    }

    componentDidMount() {
        this.setRingAnimationTimer()
    }

    componentWillUnmount() {
        this.resetRingAnimationTimer()
    }

    setRingAnimationTimer() {
        this.resetRingAnimationTimer()
        this.timer = setInterval(() => {
            this.setRingAnimationItemIndex()
        }, 2000)
        this.setRingAnimationItemIndex()
    }

    resetRingAnimationTimer() {
        clearInterval(this.timer)
    }

    setRingAnimationItemIndex() {
        this.setState({
            itemIndexRingAnimation: this.state.itemIndexRingAnimation !== 0 ? 0 : 1,
        })
    }

    render() {
        return (
            <div className="main background-red">
                <AnimatedLogo image={logo} />
                <div className="row h-100">
                    <div className="col-12 col-md-8 h-100">
                        <div className="row h-50 justify-content-center">
                            <div className="col-md-10 align-self-center">
                                <div className="row justify-content-around mt-5">
                                    <div className="col-12">
                                        <h1 className="text-white ml-3">Bauservice</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row h-50 justify-content-center">
                            <div className="col-md-10 align-self-center">
                                <div className="row justify-content-around mb-5">
                                    <div className="col-6">
                                        <IconLink
                                            ringClass={this.state.itemIndexRingAnimation === 0 ? 'pulse' : ''}
                                            className="text-white"
                                            to={`${this.props.match.path}/leistungen`}
                                            image={ServicesIcon}
                                            title="Leistungen"
                                        />
                                    </div>
                                    <div className="col-6">
                                        <IconLink
                                            ringClass={this.state.itemIndexRingAnimation === 1 ? 'pulse' : ''}
                                            className="text-white"
                                            to={`${this.props.match.path}/referenzen`}
                                            image={ReferencesIcon}
                                            title="Referenzen"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 d-sm-none d-md-block h-100">
                        <AnimatedBackgroundImage class="animated-background-image" imageStyle={{ marginTop: '40%' }} image={Mouse} maxMoveX={400} maxMoveY={400} />
                    </div>
                </div>
            </div>
        )
    }
}
